<div class="bottom-logo">
  <div class="d-flex flex-row gap-1 align-items-center">
    <small>Powered by</small>
    <img src="quidco.png" alt="Quido" class="powered-by-logo" />
  </div>
</div>